export default {
    /**
     * 设置用户信息
     * @param {Object} data 当前用户信息
     */
    setUserInfo(state, data) {
        state.userInfo = data
    },
}


// WEBPACK FOOTER //
// ./src/vuex/mutations.js